import routes from '@modules/event/event-routes';
import store from '@modules/event/event-store';

export default {
  routes,
  store,
};
